var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"ly-button",attrs:{"for":"ly-submit"}},[_vm._v("\n\n  "+_vm._s(_vm.left ? '❮' : '')+"\n  "),_vm._t("default"),_vm._v("\n  "+_vm._s(_vm.right ? '❯' : '')+"\n\n  "),(_vm.submit)?_c('input',{staticClass:"d-none",attrs:{"id":"ly-submit","type":"submit"}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfd94e6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/btn.vue
// module id = 9wdI
// module chunks = 1